import moment from "moment"
import AssMarkForm from "./AssMarkForm"


export default function SingleAssMark({ assignment }) {
    const { id, title, student_name, repo_link, mark, totalMark, status, createdAt } = assignment || {}
    return (
        <tr>
            <td className="table-td">{title}</td>
            <td className="table-td">{moment(createdAt).format('MMMM DD YYYY, h:mm:ss a')}</td>
            <td className="table-td">{student_name}</td>
            <td className="table-td">{repo_link}</td>
            {status === "pending" ?
                <AssMarkForm id={id} totalMark={totalMark} /> :
                <td className="table-td">{mark}</td>
            }
        </tr>
    )
};